import React, { useState } from "react"
import Img from "gatsby-image"
import styled, { keyframes } from "styled-components"

import { colors } from "utils/styled-constants"

const OuterWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background-color: white;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  box-shadow: ${props =>
    props.boxShadow ? props.boxShadow : "-9px 21px 60px #ebf0f4"};
  box-sizing: border-box;
  overflow: hidden;
`

const InnerWrapper = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  padding-top: 50%;
  transform: translateX(50%);
  width: 100%;
`

const StyledImg = styled(Img)`
  display: block;
  transform: translateX(-50%) translateY(-50%);
  width: 70%;
  height: auto;
`

const animateIn = keyframes`
 0% { transform: translateY(5px); opacity: 0.5; }
 100% { transform: translateY(0); opacity: 0.75; }
`

const TextWrapper = styled.div`
  position: absolute;
  width: 100%;
  left: -50%;
  bottom: 22%;
`

const ShortText = styled.p`
  font-size: 14px;
  line-height: 16px;
  color: ${colors.darkBlue};
  text-decoration: none;
  font-style: italic;
  text-align: center;
  margin: 0;
  animation: ${animateIn} 0.35s ease both;
`

const CircleLogo = ({ logo, boxShadow, shortDescription }) => {
  const [showText, setShowText] = useState(false)
  return (
    <OuterWrapper
      boxShadow={boxShadow}
      onMouseEnter={() => setShowText(true)}
      onMouseLeave={() => setShowText(false)}
    >
      <InnerWrapper>
        <StyledImg fluid={logo.fluid} />
        <TextWrapper>
          {shortDescription &&
            shortDescription.map((text, i) => {
              return <ShortText key={i}>{text}</ShortText>
            })}
        </TextWrapper>
      </InnerWrapper>
    </OuterWrapper>
  )
}

export default CircleLogo
